import { Link, useLocation } from "react-router-dom";
import Button from "../../Shared/Button/Button";

const MessageOptions = () => {
  const path = useLocation().pathname;

  return (
    <div className="flex flex-col items-center justify-center gap-3 border-l border-lightGray">
      {path !== "/user/chat" && (
        <Link to="/user/chat" className="flex w-full justify-center">
          <Button text={"View & Reply"} variant="secondary" />
        </Link>
      )}
      <Button text={"Delete Messages"} variant="red" />
    </div>
  );
};

export default MessageOptions;
